import {
  CREATE_CIC_STATUS_HISTORY,
  DELETE_CIC_STATUS_HISTORY,
  EDIT_CIC_STATUS_HISTORY,
  RECEIVE_CIC_STATUS_HISTORIES,
  REQUEST_CIC_STATUS_HISTORY,
  REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE,
} from '@sophocles/entities/CicStatusHistory/cicStatusHistoryActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CIC_STATUS_HISTORIES: // Read
      return state.merge(action.cicStatusHistories);
    case DELETE_CIC_STATUS_HISTORY: // Delete
      return state.delete(action.cicStatusHistory.toString());
    case EDIT_CIC_STATUS_HISTORY: // Update
    case CREATE_CIC_STATUS_HISTORY: // Create
    case REQUEST_CIC_STATUS_HISTORY:
    case REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE:
    default:
      return state;
  }
}

export function cicStatusHistoryReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_CIC_STATUS_HISTORY:
    case DELETE_CIC_STATUS_HISTORY:
    case RECEIVE_CIC_STATUS_HISTORIES:
    case EDIT_CIC_STATUS_HISTORY:
    case REQUEST_CIC_STATUS_HISTORY:
    case REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
